import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface IUpdateProjectUserRequest extends IBaseRequest {
  roleName?: string;
  role?: string;
  note?: string;
  id?: string;
  userId?: string;
  projectName?: string;
  acl?: string;
  project?: string;
  isPrimary?: string;
  contact?: string;
  userName?: string;
}

export class UpdateProjectUserRequest extends BaseRequest implements IUpdateProjectUserRequest {
  public roleName?: string;
  public role?: string;
  public note?: string;
  public id?: string;
  public userId?: string;
  public projectName?: string;
  public acl?: string;
  public project?: string;
  public isPrimary?: string;
  public contact?: string;
  public userName?: string;

  constructor(server: string, session: string, otherOptions: any) {
    super(server, session);
    this.roleName = otherOptions.roleName;
    this.role = otherOptions.role;
    this.note = otherOptions.note;
    this.id = otherOptions.id;
    this.userId = otherOptions.userId;
    this.projectName = otherOptions.projectName;
    this.acl = otherOptions.acl;
    this.project = otherOptions.project;
    this.isPrimary = otherOptions.isPrimary;
    this.contact = otherOptions.contact;
    this.userName = otherOptions.userName;
  }

  public toXml(): string {
    var parameters: string = super.toXml();

    parameters += this.makeNode(this.roleName, 'roleName');
    parameters += this.makeNode(this.role, 'role');
    parameters += this.makeNode(this.note, 'note');
    parameters += this.makeNode(this.id, 'id');
    parameters += this.makeNode(this.userId, 'userId');
    parameters += this.makeNode(this.projectName, 'projectName');
    parameters += this.makeNode(this.acl, 'acl');
    parameters += this.makeNode(this.project, 'project');
    parameters += this.makeNode(this.isPrimary, 'isPrimary');
    parameters += this.makeNode(this.contact, 'contact');
    parameters += this.makeNode(this.userName, 'userName');

    return super.wrapperXml('UpdateProjectUser', parameters);
  }
}
